// extracted by mini-css-extract-plugin
export default {"calcs":"Calculations-styles-module--calcs--vHL8q"};